export default "__VITE_ASSET___XU5uDhX__"